import React from 'react';
import { Outlet } from 'react-router-dom';
import HeaderPublic from './HeaderPublic';
import FooterPublic from './FooterPublic';

const PublicLayout = () => {
  return (
    <>
      <HeaderPublic />
      <Outlet />
      <FooterPublic />
    </>
  );
};

export default PublicLayout;
